import React from 'react';
import { imageSrcSetToString } from '../../../utils/imageSrcSetToString';
import { getThemeClassFromType } from '../../../utils/getThemeClassFromType';
import { Label } from '../../Label/Label';

function GenericCard(props) {
    const { type, title, url, image, attributes, resourcedTexts } = props;

    const hasImage = image.imageUrls.length > 0;
    const imageUrl = imageSrcSetToString(image.imageUrls);

    const labels = attributes.filter((item) => item.key === 'label');

    const dates = attributes.filter((item) => item.key === 'date');
    const date = dates.length > 0 && dates[0].value;

    const levels = attributes.filter((item) => item.key === 'level');
    const level = levels.length > 0 && levels[0].value;

    const texts = attributes.filter((item) => item.key === 'text');
    const text = texts.length > 0 && texts[0].value;

    const listItems = attributes.filter((item) => ['usp', 'learningPoint'].includes(item.key));

    return (
        <a href={url} className={`sfr-generic-card ${getThemeClassFromType(type)}`}>
            <div className="sfr-generic-card__top">
                {hasImage && (
                    <img
                        className={`sfr-generic-card__image ${
                            image.imageType === 'logo'
                                ? 'sfr-generic-card__image--logo'
                                : 'sfr-generic-card__image--full'
                        }`}
                        srcSet={imageUrl}
                        sizes="auto"
                        loading="lazy"
                        alt=""
                    />
                )}
            </div>

            <div className="sfr-generic-card__content">
                <div className="sfr-generic-card__labels">
                    <Label type={type} resourcedTexts={resourcedTexts} />

                    {date && <Label type="date" customText={date} />}

                    {level && <Label type="level" customText={level} />}

                    {labels.map(({ value }) => (
                        <Label key={value} type="offer" customText={value} />
                    ))}
                </div>

                <h2 className="sfr-generic-card__title">{title}</h2>

                {text && <p className="sfr-generic-card__text">{text}</p>}

                {listItems.length > 0 && (
                    <ul>
                        {listItems.map(({ value }) => (
                            <li key={value}>
                                <div>{value}</div>
                            </li>
                        ))}
                    </ul>
                )}

                <div className="sfr-generic-card__button-mobile">
                    <span className="visually-hidden">{resourcedTexts.moreInfoButton}</span>
                </div>

                <div className="sfr-generic-card__button-desktop button primary">
                    {resourcedTexts.moreInfoButton}
                </div>
            </div>
        </a>
    );
}

export { GenericCard };
